import React, { useState } from 'react';
import { Button, Form, Input, Modal, notification, Select } from 'antd';
import { createLiftoffUser } from '../../api/liftoffUserApi';
import { PlusOutlined } from '@ant-design/icons';

const CreateUserButton = ({allRoles, onComplete, style}) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form] = Form.useForm();

  const FORM_EMAIL_NAME = 'Email';
  const FORM_FNAME_NAME = 'First Name';
  const FORM_LNAME_NAME = 'Last Name';
  const FORM_ROLES_NAME = 'Roles';

  const cancel = () => {
    form.resetFields([FORM_EMAIL_NAME, FORM_FNAME_NAME, FORM_LNAME_NAME, FORM_ROLES_NAME]);
    setShowModal(false);
  };

  const showError = message => {
    notification.error({
      message: 'Create User Failed',
      description: message,
      placement: 'bottomRight',
    });
  };

  const submit = async () => {
    try {
      setLoading(true);
      const email = form.getFieldValue(FORM_EMAIL_NAME);
      const firstName = form.getFieldValue(FORM_FNAME_NAME);
      const lastName = form.getFieldValue(FORM_LNAME_NAME);
      const roles = form.getFieldValue(FORM_ROLES_NAME);
      const response = await createLiftoffUser(email, firstName, lastName, roles);

      if (response && response.status && response.status === 200) {
        notification.success({
          message: 'Success',
          description: `User ${email} has been created!`,
          placement: 'bottomRight',
        });
        onComplete();
      } else {
        showError(`User ${email} could not be created. Please contact na_opsenablement@credera.com`);
      }
    } catch (e) {
      const email = form.getFieldValue(FORM_EMAIL_NAME);
      showError(`User ${email} could not be created. Please contact na_opsenablement@credera.com. Error: ${e.message}`);
    } finally {
      setLoading(false);
      setShowModal(false);
      form.resetFields();
    }
  };

  return (
    <>
      <Button onClick={() => setShowModal(true)} loading={loading} icon={<PlusOutlined/>} style={style}>
        Create User
      </Button>

      {showModal && (
        <Form name="liftoff-create-user" form={form} onFinish={submit} labelCol={{span: 6}}>
          <Modal
            title={`Create Liftoff User`}
            open={showModal}
            footer={[
              <Button key="cancel" onClick={cancel}>Cancel</Button>,
              <Button key="submit" type="primary" onClick={() => form.submit()} loading={loading}>
                Save
              </Button>
            ]}
          >
            <Form.Item label="Email" name={FORM_EMAIL_NAME} rules={[{required: true, type: 'email'}]}>
              <Input/>
            </Form.Item>

            <Form.Item label="First Name" name={FORM_FNAME_NAME} rules={[{required: true}]}>
              <Input/>
            </Form.Item>

            <Form.Item label="Last Name" name={FORM_LNAME_NAME} rules={[{required: true}]}>
              <Input/>
            </Form.Item>

            <Form.Item label="Roles" name={FORM_ROLES_NAME} rules={[{required: true}]}>
              <Select mode="multiple" placeholder="Select role(s)">
                {allRoles.map(r => (
                  <Select.Option key={r} value={r}>
                    {r}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Modal>
        </Form>
      )}
    </>
  );
};

export { CreateUserButton };